<template>
  <div>
    <!-- 個人情報 -->
    <el-row type="flex" align="middle" :gutter="20">
      <el-col :span="4">
        <p>{{ $locale("membership.memberList.dialog.personal.title") }}</p>
      </el-col>
      <el-col :span="20" class="ta-r">
          <el-button :disabled="getDetailDisable" class="egl-btn-yellow" @click="openEdit_fn">{{ $locale("membership.memberList.dialog.personal.edit") }}</el-button>
        </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <el-form-item :label="$locale('global.name')">{{ propForm.chineseFullName }}</el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$locale('membership.memberList.dialog.personal.furigana')">{{ propForm.japaneseFullName }}</el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$locale('membership.memberList.dialog.personal.gender')">{{ getMemberGenderString(propForm.gender) }}</el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$locale('membership.memberList.dialog.personal.birthday')">{{ getBirthdayString(propForm.birthday) }}</el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$locale('membership.memberList.dialog.personal.telNumber')">{{ propForm.mobile }}</el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$locale('membership.memberList.dialog.personal.email')">{{ propForm.email }}</el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <el-form-item label="お知らせメール">{{ propForm.receiveNews ? "受信する" : "受信しない" }}</el-form-item>
      </el-col>
      <el-col :span=4>
        <el-form-item :label="$locale('global.streetAddress')">{{
          `${propForm.postalCode ? propForm.postalCode : ""} ${propForm.prefecture ? propForm.prefecture : ""} ${propForm.city ? propForm.city : ""} ${propForm.address ? propForm.address : ""}`
        }}</el-form-item>
      </el-col>
    </el-row>
    <Dialog :isOpen.sync="isDialogOpen" ref="dialog" :propForm="personalForm" />
  </div>
</template>
<script>
import Dialog from '@/components/MemberShip/MemberList/PersonalDialog.vue'
import { getMemberGender } from "@/assets/js/membership"
export default {
  inject: ["isDeatilDisable"],
  data() {
    return {
      isDialogOpen: false,
      personalForm: {
        userId: "",
        chineseLastName: "",
        chineseFullName: "",
        japaneseLastName: "",
        japaneseFullName: "",
        birthday: "",
        mobile: "",
        gender: "",
        postalCode1: "",
        postalCode2: "",
        prefecture: "",
        city: "",
        address: "",
        email: "",
        receiveNews: false,
      },
      getMemberGender,
    }
  },
  computed: {
    getDetailDisable() {
      return this.isDeatilDisable()
    }
  },
  methods: {
    openEdit_fn() {
      const { chineseName, chineseFullName, chineseLastName, japaneseName, japaneseFullName, japaneseLastName,
      birthday, mobile, gender, postalCode, prefecture, city, address, email, id, receiveNews } = this.propForm
      this.personalForm = {
        userId: id,
        chineseName,
        chineseFullName,
        chineseLastName,
        japaneseName,
        japaneseFullName,
        japaneseLastName,
        birthday,
        mobile,
        gender,
        postalCode1: postalCode ? postalCode.split("-")[0] : "",
        postalCode2: postalCode ? postalCode.split("-")[1] : "",
        prefecture,
        city,
        address,
        email,
        receiveNews,
      }
      this.isDialogOpen = true
    },
    getMemberGenderString(gender) {
      try {
        const curPermission = window.localStorage.getItem("permissionMap");
        if (!curPermission) {
          // 如果没有权限信息，直接返回性别标签
          const genderList = this.getMemberGender();
          if (!genderList || !Array.isArray(genderList)) {
            return "";
          }
          const found = genderList.find(item => item && item.value === gender);
          return found ? found.label : "";
        }

        let permissionMap;
        try {
          permissionMap = JSON.parse(curPermission);
        } catch (e) {
          // JSON 解析失败，直接返回性别标签
          const genderList = this.getMemberGender();
          if (!genderList || !Array.isArray(genderList)) {
            return "";
          }
          const found = genderList.find(item => item && item.value === gender);
          return found ? found.label : "";
        }

        // 检查权限结构是否存在
        if (permissionMap && permissionMap.cl_membership && permissionMap.cl_membership.types && Array.isArray(permissionMap.cl_membership.types)) {
          const isHaveMask = permissionMap.cl_membership.types.includes("mask");
          const isHaveEdit = permissionMap.cl_membership.types.includes("edit");
          if (!isHaveEdit && isHaveMask) {
            return "******";
          }
        }

        // 返回性别标签
        const genderList = this.getMemberGender();
        if (!genderList || !Array.isArray(genderList)) {
          return "";
        }
        const found = genderList.find(item => item && item.value === gender);
        return found && found.label ? found.label : "";
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("getMemberGenderString error:", error);
        return "";
      }
    },
    getBirthdayString(birthday) {
      try {
        const curPermission = window.localStorage.getItem("permissionMap");
        if (!curPermission) {
          // 如果没有权限信息，直接返回格式化的生日
          if (!birthday) {
            return "";
          }
          if (this.$moment && this.$moment(birthday).isValid()) {
            return this.$moment(birthday).format("YYYY.MM.DD");
          }
          return "";
        }

        let permissionMap;
        try {
          permissionMap = JSON.parse(curPermission);
        } catch (e) {
          // JSON 解析失败，直接返回格式化的生日
          if (!birthday) {
            return "";
          }
          if (this.$moment && this.$moment(birthday).isValid()) {
            return this.$moment(birthday).format("YYYY.MM.DD");
          }
          return "";
        }

        // 检查权限结构是否存在
        if (permissionMap && permissionMap.cl_membership && permissionMap.cl_membership.types && Array.isArray(permissionMap.cl_membership.types)) {
          const isHaveMask = permissionMap.cl_membership.types.includes("mask");
          const isHaveEdit = permissionMap.cl_membership.types.includes("edit");
          if (!isHaveEdit && isHaveMask) {
            return "******";
          }
        }

        // 返回格式化的生日
        if (!birthday) {
          return "";
        }
        if (this.$moment && this.$moment(birthday).isValid()) {
          return this.$moment(birthday).format("YYYY.MM.DD");
        }
        return "";
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("getBirthdayString error:", error);
        return "";
      }
    }
    // getPostCode_fn(str) {
    //   const _str = String(str)
    //   const code1 = _str.substring(0, 2)
    // }
  },
  components: {
    Dialog
  },
  props: {
    propForm: {
      type: Object,
      default: () => {}
    }
  }
}
</script>